import { useState, useEffect, useCallback } from "react";

const ZoomHandler = ({
  initialScale = 1.0,
  onZoomChange,
  onFieldsConstrain,
}) => {
  const [scale, setScale] = useState(initialScale);

  const handleZoomIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (scale < 1.6) {
      const newScale = Math.min(1.6, scale + 0.1);
      setScale(newScale);
      onZoomChange(newScale);
      // Constrain fields to new boundaries after zoom change
      setTimeout(() => onFieldsConstrain(newScale), 0);
    }
  };

  const handleZoomOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (scale > 0.6) {
      const newScale = Math.max(0.6, scale - 0.1);
      setScale(newScale);
      onZoomChange(newScale);
      // Constrain fields to new boundaries after zoom change
      setTimeout(() => onFieldsConstrain(newScale), 0);
    }
  };

  const handleZoomReset = useCallback(() => {
    setScale(1.0);
    onZoomChange(1.0);
    setTimeout(() => onFieldsConstrain(1.0), 0);
  }, [onZoomChange, onFieldsConstrain]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (
        (e.ctrlKey || e.metaKey) &&
        (e.key === "+" || e.key === "-" || e.key === "0" || e.key === "=")
      ) {
        e.preventDefault();
        e.stopPropagation();
        if (e.key === "+" || e.key === "=") {
          if (scale < 1.6) {
            const newScale = Math.min(1.6, scale + 0.1);
            setScale(newScale);
            onZoomChange(newScale);
            setTimeout(() => onFieldsConstrain(newScale), 0);
          }
        } else if (e.key === "-") {
          if (scale > 0.6) {
            const newScale = Math.max(0.6, scale - 0.1);
            setScale(newScale);
            onZoomChange(newScale);
            setTimeout(() => onFieldsConstrain(newScale), 0);
          }
        } else if (e.key === "0") {
          handleZoomReset();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [scale, onZoomChange, onFieldsConstrain, handleZoomReset]);

  return {
    scale,
    handleZoomIn,
    handleZoomOut,
    handleZoomReset,
  };
};

export default ZoomHandler;
